import { DescriptorAction } from "../descriptor";

export class TableSelectionItem {
    action: DescriptorAction = new DescriptorAction;
    item: any = {};
}